import { Outlet} from 'src/navigation'
import { LoadingModal } from 'src/components/Modal'
import { useDennemeyer } from './DennemeyerProvider'

export default function AnnuitiesMenu() {
    const {isLoading} = useDennemeyer()

    return isLoading ? <LoadingModal /> : <Outlet />
}